export default __webpack_public_path__ + "static/media/delearship.52361bbb.png";